import React, { lazy, Suspense } from 'react'

const NewsContainer = lazy(() => import('../News/NewsContainer'))

interface NewsViewProps {
  hideMenu?: boolean
  isRetorikNews?: boolean
  handleEndedWithoutloop?: () => void
}

const NewsView = ({ hideMenu, isRetorikNews, handleEndedWithoutloop }: NewsViewProps): JSX.Element => {
  return (
    <Suspense>
      <NewsContainer hideMenu={hideMenu} isRetorikNews={isRetorikNews} handleEndedWithoutloop={handleEndedWithoutloop} />
    </Suspense>
  )
}

export default NewsView
